import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store';
import { Provider } from 'react-redux';



const rootElement = document.getElementById('root');

// Check if the root element exists before attempting to render
if (rootElement) {
  // Instead of ReactDOM.render, use createRoot
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>      
          <App />            
      </Provider>
    </React.StrictMode>
  );
} 